import React, { createContext, useContext, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { supabase } from '../utils/supabase';

const ProfileSyncContext = createContext();

export function ProfileSyncProvider({ children }) {
  const { userProfile, refreshUserProfile } = useAuth();

  useEffect(() => {
    if (!userProfile?.id) return;
    
    // Subscribe to profile changes for real-time updates
    const channel = supabase
      .channel(`public:user_profiles:id=eq.${userProfile.id}`)
      .on('postgres_changes', { 
        event: 'UPDATE', 
        schema: 'public',
        table: 'user_profiles',
        filter: `id=eq.${userProfile.id}`
      }, (payload) => {
        console.log('Profile updated, refreshing user data');
        refreshUserProfile();
      })
      .subscribe();
      
    return () => {
      channel.unsubscribe();
    };
  }, [userProfile?.id, refreshUserProfile]);

  return (
    <ProfileSyncContext.Provider value={{}}>
      {children}
    </ProfileSyncContext.Provider>
  );
}

export const useProfileSync = () => useContext(ProfileSyncContext);